export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es', 'en'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: '0d3e1afa-3059-49a5-a34f-f31d90d54e18',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'goreassist.alares',

  /**
  * Nombre de la app
  */
  appName: 'GORE ASSIST',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-0ZG2DVGCK4',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: false,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false,
  videoCallsUrl: 'https://videollamada.vivofacil.com/?kid=AljJRe39SLEsWhMFg2pqTrA',
    
  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'es',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Alares',
   
   /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'alares'
};
